export default function GoogleMap({ className, style, ...props }) {
  return (
    <iframe
      title='map'
      style={{
        width: "100%",
        height: "300px",
        borderRadius: "20px",
        ...style,
      }}
      src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2883.798940277393!2d-79.31543274872995!3d43.714727279016856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cd1093170493%3A0x49fe692c4ded4364!2sOff%20Cut%20Shades!5e0!3m2!1sen!2sca!4v1579535251248!5m2!1sen!2sca'
      {...props}
    />
  );
}
